import { render, staticRenderFns } from "./CookieDialog.vue?vue&type=template&id=cac4d760&scoped=true&"
import script from "./CookieDialog.vue?vue&type=script&lang=ts&"
export * from "./CookieDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac4d760",
  null
  
)

export default component.exports